import React, { useContext, useRef } from "react";
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import axios from "../../axios";
import { imageUrl, imageUrl2, API_KEY, baseUrl } from "../../Constants/Constance";
// import useUpdateMylist from "../../CustomHooks/useUpdateMylist";
import YouTube from "react-youtube";
import StarRatings from "react-star-ratings";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import usePlayMovie from "../../CustomHooks/usePlayMovie";
import usePlaySerie from "../../CustomHooks/usePlaySerie";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./RowPostStyles.scss";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../axios-client";
import { AuthContext } from "../../Context/UserContext";
import usePlayVideo from "../../CustomHooks/usePlayVideo";
import ContentPopup from "../Popup/ContentPopup";
import SeriePopup from "../Popup/SeriePopup";

function RowPost(props) {
  const { playMovie } = usePlayMovie();
  const { playSerie } = usePlaySerie();
  const { playVideo } = usePlayVideo();
  const navigate = useNavigate()
  const [content, setContent] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [moviePopupInfo, setMoviePopupInfo] = useState({});
  const [shouldPop, setshouldPop] = useState(true);
  const [urlId, setUrlId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { user, profileId, userCountryCode } = useContext(AuthContext);

  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredCard, setIsHoveredCard] = useState(false);
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);

  const [currentPage, setCurrentPage] = useState(1); // Current page of data
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const fetchContentData = async (page = 1) => {
    try {
      setIsLoading(true);

      let response;
      let newData = [];
      const pageSize = 25
      if (props.WatchHistory) {
        response = await axiosClient.get(`watch-history/profile/${profileId}/?page=1&page_size=999`);
        const allData = response.data.results;
        console.log(allData);

        // Combine movies and episodes into the same structure
        newData = allData.map((item) => {
          return {
            id: item.id,
            type: item.movie_data ? 'movie' : 'episode',
            idContent: item.movie_data?.id || item.episode_data?.id,
            title: item.movie_data?.title || item.episode_data?.title,
            image: item.movie_data?.image || item.episode_data?.Serie_image,
            poster: item.movie_data?.poster || item.episode_data?.Serie_poster,
            releaseDate: item.movie_data?.releaseDate || item.episode_data?.releaseDate,
            videoUrl: item.movie_data?.videoUrl || item.episode_data?.videoUrl,
            duration: item.movie_data?.duration || item.episode_data?.duration,
            progress: item.progress,
            pays_codes: item.movie_data?.pays_codes || item.episode_data?.pays_codes,

          };
        });


      }
      else if (props.isSerie) {
        response = await axiosClient.get(`series/?profile_id=${profileId}&page_size=${pageSize}&page=1`);
        newData = response.data.results || [];
      } else if (props.isNew) {
        // No pagination, no page parameter for 'newest' endpoint
        response = await axiosClient.get(`content/newest/?profile_id=${profileId}`);
        newData = response.data || []; // Directly use response.data for newest content
      } else {
        response = await axiosClient.get(`content/category/${props.url}/?profile_id=${profileId}&page_size=${pageSize}&page=1`);
        newData = response.data.results || [];
      }
      // Update the Swiper content
      // setContent((prevContent) =>
      //   page === 1 ? newData : [...prevContent, ...newData]
      // );
      setContent(newData);

      // Check if there's more data to load
      // setHasMore(response.data.next !== null);
      setIsLoading(false);
    } catch (error) {
      // console.error("Error fetching the content data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true)

    if (userCountryCode && profileId) {
      fetchContentData();
    }

  }, [props.url, profileId, userCountryCode]);

  const customSettings = {
    breakpoints: {
      2000: { slidesPerView: 7.1, slidesPerGroup: 7 },
      1800: { slidesPerView: 6.1, slidesPerGroup: 5 },
      1690: { slidesPerView: 5.5, slidesPerGroup: 5 },
      1536: { slidesPerView: 5, slidesPerGroup: 5 },
      1220: { slidesPerView: 4.3, slidesPerGroup: 4 },
      700: { slidesPerView: 3.1, slidesPerGroup: 3 },
      653: { slidesPerView: 4.5, slidesPerGroup: 4 },
      500: { slidesPerView: 4.1, slidesPerGroup: 4 },
      450: { slidesPerView: 3.5, slidesPerGroup: 3 },
      400: { slidesPerView: 3.1, slidesPerGroup: 3 },
      330: { slidesPerView: 2.8, slidesPerGroup: 2 },
      0: { slidesPerView: 2, slidesPerGroup: 2 },
    },
  };
  // const customSettings = {
  //   breakpoints: {
  //     1800: { slidesPerView: 6.1, slidesPerGroup: 5 },
  //     1690: { slidesPerView: 5.5, slidesPerGroup: 5 },
  //     1536: { slidesPerView: 5, slidesPerGroup: 5 },
  //     1280: { slidesPerView: 4.3, slidesPerGroup: 4 },
  //     768: { slidesPerView: 3.3, slidesPerGroup: 3 },
  //     600: { slidesPerView: 3.1, slidesPerGroup: 3 },
  //     330: { slidesPerView: 3.1, slidesPerGroup: 3 },
  //     0: { slidesPerView: 3, slidesPerGroup: 3 },
  //   },
  // };

  const opts = {
    width: "100%",
    height: "auto",
    playerVars: {
      autoplay: 1,
      controls: 0,
    },
    modestbranding: 1,
    rel: 0,
    autohide: 1,
    showinfo: 0,
  };

  const handleMoviePopup = (movieInfo) => {
    if (!isLoading && !userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }
    if (movieInfo?.pays_codes?.length > 0 && !movieInfo?.pays_codes?.includes(userCountryCode)) {
      toast.error(`Désolé, ce contenu n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      // alert("Désolé, ce film n'est pas disponible dans votre pays.");
      return;
    }
    setMoviePopupInfo(movieInfo);
    setShowModal(true);
  };



  const handleFavoriteClick = async (content, title) => {
    if (!userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }
    if (content?.pays_codes?.length > 0 && !content?.pays_codes?.includes(userCountryCode)) {
      toast.error(`Désolé, ce film n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      // alert("Désolé, ce film n'est pas disponible dans votre pays.");
      return;
    }
    if (content.isLiked) {
      // If already favorited, remove it
      try {
        const response = await axiosClient.delete(`favorites/delete/${profileId}/${content.id}/`);
        if (response.status === 204) {
          setContent(prevData => {
            return prevData.map(val => {
              if (val.id === content?.id) {
                return {
                  ...val,
                  isLiked: false
                };
              }
              return val;
            });
          });

          setMoviePopupInfo({ ...moviePopupInfo, isLiked: false });
        }
        toast.error(`${title} a été retiré de vos favoris.`, {
          position: "top-right",
          autoClose: 3000,

        });
      } catch (error) {
        // console.error('Error removing from favorites', error);
      }
    } else {
      // If not favorited, add it
      try {
        const response = await axiosClient.post('favorites/create/', {
          profile: profileId,
          content: content.id,
        });
        if (response.status === 201) {
          setContent(prevData => {
            return prevData.map(val => {
              if (val.id === content?.id) {
                return {
                  ...val,
                  isLiked: true
                };
              }
              return val;
            });
          });
          setMoviePopupInfo({ ...moviePopupInfo, isLiked: true });
        }
        toast.success(`${title} a été ajouté à vos favoris.`, {
          position: "top-right",
          autoClose: 3000,

        });
      } catch (error) {
        // console.error('Error adding to favorites', error);
      }
    }
  };
  // const [userCountryCode, setUserCountryCode] = useState(null);

  // useEffect(() => {
  //   axiosClient.get("/get-ip-and-country/")
  //     .then(response => {
  //       setUserCountryCode(response.data.code); 
  //     })
  //     .catch(error => console.error("Error fetching country:", error));
  // }, []);

  const handleMovieClick = (obj) => {
    if (!isLoading && !userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }
    if (obj?.pays_codes?.length > 0 && !obj?.pays_codes?.includes(userCountryCode)) {
      toast.error(`Désolé, ce contenu n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      // alert("Désolé, ce film n'est pas disponible dans votre pays.");
      return;
    }

    props.WatchHistory
      ? playVideo(obj.idContent, obj.type === "movie" ? "movie" : "episode")
      : handleMoviePopup(obj);
  };
  const handleCardClick = (obj) => {
    if (!isLoading && !userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }
    if (obj?.pays_codes?.length > 0 && !obj?.pays_codes?.includes(userCountryCode)) {
      toast.error(`Désolé, ce contenu n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }

    obj.type === "series" ? playSerie(obj) : playMovie(obj)
  };

  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowModal]);

  const handlePlayClick = async (content, type) => {
    if (!userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;

    }
    if (content?.pays_codes?.length > 0 && !content?.pays_codes?.includes(userCountryCode)) {
      toast.error(`Désolé, ce film n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      // alert("Désolé, ce film n'est pas disponible dans votre pays.");
      return;
    }
    playVideo(content?.id, type === "movie" ? "movie" : "episode")

  }
  return (
    <div
      className="ml-5 mt-2 lg:ml-11 mb-11 lg:mb-2 RowContainer"
      style={{ marginTop: `${props.first ? "-8rem" : ""}` }}
    >
      {/* {PopupMessage}
      {removePopupMessage} */}
      {/* <ToastContainer /> */}

      {!isLoading ? (
        <>
          <h1 className="text-white pb-2 xl:pb-0 font-bold text-base sm:text-2xl md:text-3xl">
            {props.title}
          </h1>

          <Swiper
            {...customSettings}
            modules={[Navigation, Pagination]}
            spaceBetween={15}
            slidesPerView={6.1}
            navigation
            pagination={false}
            className="SwiperStyle h-full"
          >
            {content.map((obj, index) => {
              // const converted = convertGenere(obj.genre_ids);
              return (
                <SwiperSlide
                  key={index}
                  // className={props.islarge ? "large" : "bg-cover"}
                  className={"bg-cover"}
                  onMouseLeave={() => setHoveredCardIndex(null)}
                  onClick={() => {
                    if (props.WatchHistory) {
                      handleMovieClick(obj);
                    } else {
                      handleCardClick(obj)

                    }

                  }}
                // onClick={() => props.WatchHistory ? handleMovieClick(obj) : null }
                >

                  <div
                    onMouseEnter={() => setHoveredCardIndex(index)}
                    onMouseLeave={() => setHoveredCardIndex(null)}
                  >
                    {props.islarge ? (

                      hoveredCardIndex === index ? (
                        <video
                        className={`rounded-xl ${screenWidth < 700 ? "w-[130px] h-[190px]" : "min-h-[130px] max-h-[130px] sm:min-h-[160px] sm:max-h-[160px] md:min-h-[190px] md:max-h-[190px] w-[100%]"}  object-fill `}
                        src={obj.trailerUrl}
                          poster={screenWidth < 700 ? obj.poster : obj.image}
                          onPause={() => setIsHoveredCard(false)}
                          autoPlay
                          muted
                          loop
                        />
                      ) : (
                        <img
                          className={`rounded-xl ${screenWidth < 700 ? "w-[130px] h-[190px]" : "min-h-[130px] max-h-[130px] sm:min-h-[160px] sm:max-h-[160px] md:min-h-[190px] md:max-h-[190px] w-[100%]"}  object-fill `}
                          src={screenWidth < 700 ? obj.poster : obj.image}
                        />
                      )

                    ) : (
                      <>
                        {hoveredCardIndex === index ? (
                          <video
                            className={
                              props.WatchHistory
                              ? `rounded-sm  ${screenWidth < 700 ? "w-[120px] h-[185px]" : "min-h-[120px] max-h-[120px] sm:min-h-[145px] sm:max-h-[145px] md:min-h-[175px] md:max-h-[175px] w-[100%]"} object-fill`
                              : `rounded-xl ${screenWidth < 700 ? "w-[120px] h-[185px]" : "min-h-[120px] max-h-[120px] sm:min-h-[145px] sm:max-h-[145px] md:min-h-[175px] md:max-h-[175px] w-[100%]"}  object-fill `
                          }
                            src={obj.trailerUrl}
                            poster={screenWidth < 700 ? obj.poster : obj.image}
                            onPause={() => setIsHoveredCard(false)}
                            autoPlay
                            muted
                            loop
                          />
                        ) : (
                          <img
                            loading="lazy"
                            className={
                              props.WatchHistory
                              ? `rounded-sm  ${screenWidth < 700 ? "w-[120px] h-[185px]" : "min-h-[120px] max-h-[120px] sm:min-h-[145px] sm:max-h-[145px] md:min-h-[175px] md:max-h-[175px] w-[100%]"} object-fill`
                              : `rounded-xl ${screenWidth < 700 ? "w-[120px] h-[185px]" : "min-h-[120px] max-h-[120px] sm:min-h-[145px] sm:max-h-[145px] md:min-h-[175px] md:max-h-[175px] w-[100%]"}  object-fill `
                          }
                            src={
                              obj.image
                                ? `${screenWidth < 700 ? (obj.poster ? obj.poster:obj.image) : obj.image}`
                                : "https://play-lh.googleusercontent.com/Oyl8qNPlgau19prJodKkddTMAJvS3PiDskUtSUTkefp6KyiwSa7K7BTZU1GiyNOeUPKC=w240-h480-rw"
                            }
                          />
                        )}
                        {props.WatchHistory &&
                          <div className="w-full bg-gray-200 rounded-full h-1  dark:bg-gray-600">
                            <div className={`bg-orange-600 h-1  dark:bg-orange-400 `} style={{
                              width: `${(parseInt(obj.progress) / parseInt(obj.duration)) * 100}%`
                            }}></div>
                          </div>}
                      </>
                    )}
                  </div>

                  {props.WatchHistory && (
                    <div className="content-dark h-full absolute inset-0 bg-black/60  z-10">
                      <div className="flex items-center justify-center h-full w-full">
                        <span className=" text-white text-center text-lg font-bold">Continuer la lecture</span>
                      </div>
                    </div>
                  )}
                  <div className="content pt-16">

                    {/* <Fade bottom duration={300}> */}
                    {obj.logo &&
                      <div className=" mb-2 text-white ml-4 font-medium h-[50px] w-[100px] flex  ">
                        <img className="object-fit" src={obj.logo} />
                      </div>}
                    {!props.WatchHistory &&
                      <div className="flex transition mb-1 ml-3 ease-in-out delay-150">
                        <div
                          onClick={(e) => {
                            if (props.WatchHistory) {
                              e.stopPropagation()
                              handlePlayClick(obj, obj.type)
                            }
                            else {
                              e.stopPropagation()
                              { obj.type === "movie" ? handlePlayClick(obj, obj.type) : playSerie(obj) }
                              // handleMovieClick(obj)
                            }
                            // e.stopPropagation()
                            // handlePlayClick(obj, obj.type)
                            // playVideo(obj.idContent, obj.type === "movie" ? "movie" : "episode")
                          }}
                          onMouseEnter={() => setshouldPop(false)}
                          onMouseLeave={() => setshouldPop(true)}
                          className="text-white w-8 h-8 border-[2px] rounded-full p-2 mr-1 backdrop-blur-[2px] shadow-md ease-linear transition-all duration-150 hover:text-black hover:bg-white"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
                            />
                          </svg>
                        </div>

                        <div
                          onClick={(e) => {
                            e.stopPropagation()
                            handleFavoriteClick(obj, obj.title)
                          }}
                          onMouseEnter={() => setshouldPop(false)}
                          onMouseLeave={() => setshouldPop(true)}
                          className="text-white w-8 h-8 border-[2px] rounded-full p-2 mr-1 backdrop-blur-[1px] shadow-md ease-linear transition-all duration-150 hover:text-black hover:bg-white"
                        >
                          {obj.isLiked ? (
                            // Filled heart icon (Favorite)
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="white"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                              />
                            </svg>
                          ) : (
                            // Empty heart icon (Not Favorite)
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                              />
                            </svg>
                          )}
                        </div>

                        <div
                          onClick={(e) =>
                          (e.stopPropagation(),
                            handleMoviePopup(obj))
                          }
                          className="text-white w-8 h-8 border-[2px] rounded-full p-2 mr-1 backdrop-blur-[1px] shadow-md ease-linear transition-all duration-150 hover:text-black hover:bg-white"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="text-shadow-xl"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                            />
                          </svg>
                        </div>
                      </div>}

                    {/* <h1 className="text-white ml-4 font-medium w-4/5 xl:line-clamp-1">
                      {obj.name || obj.title}
                    </h1> */}

                    {/* } */}
                    <h1 className="text-white text-xs font-semibold ml-4 w-11/12">
                      {obj.releaseDate.split("-")[0]}

                    </h1>


                  </div>
                </SwiperSlide>
              );
            })}
            {((!props.isNew && !props.WatchHistory) && content?.length >= 20) &&
              <SwiperSlide
                key="show-more"
                className=" flex justify-center items-center h-full bg-black/50 backdrop-blur-sm rounded-xl text-white text-center cursor-pointer"
                onClick={() => navigate(`/${props.title.toLowerCase().replace(" ", "-")}`, {
                  state: {
                    catId: props.url,
                  },
                })}
              >
                <div className={props.islarge ? `rounded-xl ${screenWidth < 700 ? " flex justify-center items-center  w-[130px] h-[190px]" : "flex justify-center items-center min-h-[130px] max-h-[130px] sm:min-h-[160px] sm:max-h-[160px] md:min-h-[190px] md:max-h-[190px] w-[100%]"}  object-fill ` :
                  `rounded-xl ${screenWidth < 700 ? " flex justify-center items-center  w-[120px] h-[185px]" : "flex justify-center items-center min-h-[120px] max-h-[120px] sm:min-h-[145px] sm:max-h-[145px] md:min-h-[175px] md:max-h-[175px] w-[100%]"}  object-fill `}>
                  <h2>Voir plus</h2>
                </div>

              </SwiperSlide>
            }

          </Swiper>
        </>
      ) : (
        <>
          <div className="animate-pulse">
            <div className="w-72 ml-1 mt-2 sm:ml-0 sm:w-96 py-5 mb-5 xl:py-4 2xl:py-6 xl:w-45rem bg-neutral-900 rounded-md"></div>
            <div className="w-91% md:w-98% ml-1 mb-14 sm:ml-0 py-16 md:py-24  bg-neutral-900 rounded-md"></div>
          </div>
        </>
      )}

      <>
        {/* Movie Pop Up section */}
        <AnimatePresence>
          {showModal && (
            moviePopupInfo.type === "series" ? <>
              <SeriePopup
                modalRef={modalRef}
                popupInfo={moviePopupInfo}
                playSerie={playSerie}
                playMovie={playMovie}
                handleFavoriteClick={handleFavoriteClick}
                setShowModal={setShowModal}
              />
              <div className="opacity-50 fixed inset-0 z-40 bg-gray-800"></div>
            </> :
              <>
                <ContentPopup
                  modalRef={modalRef}
                  popupInfo={moviePopupInfo}
                  playSerie={playSerie}
                  playMovie={playMovie}
                  handleFavoriteClick={handleFavoriteClick}
                  setShowModal={setShowModal}
                />
                <div className="opacity-50 fixed inset-0 z-40 bg-gray-800"></div>
              </>
          )}
        </AnimatePresence>

      </>
    </div>
  );
}

export default RowPost;
